import { render, staticRenderFns } from "./PurchaseCompletePage.vue?vue&type=template&id=05ce5aa9&scoped=true"
import script from "./PurchaseCompletePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./PurchaseCompletePage.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PurchaseCompletePage.vue?vue&type=style&index=0&id=05ce5aa9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ce5aa9",
  null
  
)

export default component.exports